import React, { useMemo, FC } from 'react';
import { useQuery } from '@apollo/client';

import { GET_IS_USER_LOGGED_IN } from '../../../graphql/user/queries';
import { loggedUserWrapper } from './logged-user-wrapper';
import { AppointmentSettingsProps } from './appointment-settings.models';

export function appointmentSettings<T = {}>(Component: FC<T & AppointmentSettingsProps>) {
  return (props: T & Omit<AppointmentSettingsProps, 'isLoggedIn'>) => {
    const { data: { user: { isLoggedIn } } } = useQuery(GET_IS_USER_LOGGED_IN);
    const WrappedComponent = useMemo(() => isLoggedIn
      ? loggedUserWrapper(Component)
      : Component,
    [isLoggedIn]);

    return  <WrappedComponent {...props as T & AppointmentSettingsProps} isLoggedIn={isLoggedIn} />;
  };
}
